export const SEARCH_WORK_ORDER_TYPE_ASYNC = 'SEARCH_WORK_ORDER_TYPE_ASYNC';
export const SEARCH_WORK_ORDER_TYPE_SUCCESS = 'SEARCH_WORK_ORDER_TYPE_SUCCESS';
export const CREATE_WORK_ORDER_TYPE_ASYNC = 'CREATE_WORK_ORDER_TYPE_ASYNC';
export const UPLOAD_WORK_ORDER_TYPE_ASYNC = 'UPLOAD_WORK_ORDER_TYPE_ASYNC';
export const ADD_EDIT_WORK_ORDER_TYPE_ERROR = 'ADD_EDIT_WORK_ORDER_TYPE_ERROR';
export const RESET_WORK_ORDER_TYPE = 'RESET_WORK_ORDER_TYPE';
export const SEARCH_REQUEST_WORK_TYPE_ASYNC = 'SEARCH_REQUEST_WORK_TYPE_ASYNC';
export const SEARCH_REQUEST_WORK_TYPE_SUCCESS = 'SEARCH_REQUEST_WORK_TYPE_SUCCESS';
export const CREATE_REQUEST_WORK_TYPE_ASYNC = 'CREATE_REQUEST_WORK_TYPE_ASYNC';
export const UPDATE_REQUEST_WORK_TYPE_ASYNC = 'UPDATE_REQUEST_WORK_TYPE_ASYNC';
export const OPEN_FORM_CREATE_REQUEST_WORK_TYPE = 'OPEN_FORM_CREATE_REQUEST_WORK_TYPE';
export const CLOSE_FORM_CREATE_REQUEST_WORK_TYPE = 'CLOSE_FORM_CREATE_REQUEST_WORK_TYPE';
export const GET_REQUEST_WORK_TYPE_BY_ID_ASYNC = 'GET_REQUEST_WORK_TYPE_BY_ID_ASYNC';
export const GET_REQUEST_WORK_TYPE_BY_ID_SUCCESS = 'GET_REQUEST_WORK_TYPE_BY_ID_SUCCESS';
export const ADD_EDIT_REQUEST_WORK_TYPE_ERROR = 'ADD_EDIT_REQUEST_WORK_TYPE_ERROR';
export const RESET_REQUEST_WORK_TYPE = 'RESET_REQUEST_WORK_TYPE';
export const MAKE_ACTIVE_WORK_TYPE_ASYNC = 'MAKE_ACTIVE_WORK_TYPE_ASYNC';
export const MAKE_INACTIVE_WORK_TYPE_ASYNC = 'MAKE_INACTIVE_WORK_TYPE_ASYNC';
export const SELECT_LIST_WOT_ASYNC = 'SELECT_LIST_WOT_ASYNC';
export const SELECT_LIST_WOT_SUCCESS = 'SELECT_LIST_WOT_SUCCESS';



// WEBPACK FOOTER //
// ./src/Work-Order-Type/constants.js